<script lang="ts">
import { type TimelineItem } from '~/models/arbitrary';
</script>

<script setup lang="ts">
import Timeline from '~/components/common/Timeline.vue';

const {
  public: { cdnUrl },
} = useRuntimeConfig();
const { t } = useI18n();
const items = computed<TimelineItem[]>(() => [
  {
    id: '326a2bc8-db2e-4cd7-ae3b-ee2c9c84f66b',
    title: t('homepage.step-by-step.steps.1.title'),
    content: t('homepage.step-by-step.steps.1.text'),
    position: 'right',
  },
  {
    id: '25e48e72-bfd8-453a-aea2-316403e7db14',
    title: t('homepage.step-by-step.steps.2.title'),
    content: t('homepage.step-by-step.steps.2.text'),
    position: 'right',
  },
  {
    id: 'bdbc466d-d049-4674-9115-313b4b64570f',
    title: t('homepage.step-by-step.steps.3.title'),
    content: t('homepage.step-by-step.steps.3.text'),
    position: 'right',
  },
]);
</script>

<template>
  <div class="row">
    <div class="col justify-center image-column">
      <picture>
        <img
          alt=""
          aria-hidden="true"
          loading="lazy"
          class="image"
          :src="`${cdnUrl}/images/redesign/homepage/step-by-step.png`"
          :srcset="`${cdnUrl}/images/redesign/homepage/step-by-step@2x.png 2x, ${cdnUrl}/images/redesign/homepage/step-by-step@3x.png 3x`"
        />
      </picture>
    </div>

    <div class="col">
      <Timeline :items="items" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.image {
  width: 100%;
  min-height: auto;
}
</style>
